// Module
var code = "<input autocomplete=\"new-password\" class=\"_data full\" type=\"password\"> ";
// Exports
export default code;